import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Slider from "react-slick";
import servicesData from "../Components/Data/ServiceData";
import backgroundImage from "../Assets/img/blog/freepik__candid-image-photography-natural-textures-highly-r__73737.jpeg"

const ServiceSection = () => {
  const [lightboxService, setLightboxService] = useState(null);
  const [readMore, setReadMore] = useState(false);

  const openLightbox = (service) => {
    setLightboxService(service);
    setReadMore(false);
  };

  const closeLightbox = () => {
    setLightboxService(null);
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <Section>
        <Container>
          <SectionHeader>
            <h2>What We Offer</h2>
          </SectionHeader>
          <SliderWrapper>
            <Slider {...sliderSettings}>
              {servicesData.map((service) => (
                <ServiceCard key={service.id}>
                  <CardImageWrapper>
                    <CardImage src={service.image} alt={service.title} />
                  </CardImageWrapper>
                  <ServiceTitle onClick={() => openLightbox(service)}>
                    {service.title}
                  </ServiceTitle>
                  <ServiceDescription>
                    {window.innerWidth <= 768 && !readMore
                      ? service.description.slice(0, 100) + "..."
                      : service.description}
                  </ServiceDescription>
                  {window.innerWidth <= 768 && (
                    <ReadMoreButton onClick={() => setReadMore(!readMore)}>
                      {readMore ? "Show Less" : "Read More"}
                    </ReadMoreButton>
                  )}
                </ServiceCard>
              ))}
            </Slider>
          </SliderWrapper>
        </Container>
      </Section>

      {lightboxService && (
        <LightboxOverlay onClick={closeLightbox}>
          <LightboxContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={closeLightbox}>&times;</CloseButton>
            <LightboxTitle>{lightboxService.title}</LightboxTitle>
            <LightboxImage src={lightboxService.image} alt={lightboxService.title} />
            <LightboxDescription>
              {window.innerWidth <= 768 && !readMore
                ? lightboxService.details.slice(0, 100) + "..."
                : lightboxService.details}
            </LightboxDescription>
            {window.innerWidth <= 768 && (
              <ReadMoreButton onClick={() => setReadMore(!readMore)}>
                {readMore ? "Show Less" : "Read More"}
              </ReadMoreButton>
            )}
            <CTAButton as={Link} to={`/services/${lightboxService.id}`}>
              Get Started
            </CTAButton>
          </LightboxContent>
        </LightboxOverlay>
      )}
    </>
  );
};

export default ServiceSection;



// Styled Components


const Section = styled.section`
  position: relative;
  padding: 40px 20px;
background: linear-gradient(to bottom, #ffffff, #f9fafb);
color: #333333;
  z-index: 1;

  // &::before {
  //   content: '';
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   background: rgba(15, 15, 15, 0.1); /* Blue overlay */
  //   z-index: -1;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 20px;

  h2 {
    font-size: 2.5rem;
    font-weight: 800;
    color: #33333;
  }
`;

const SliderWrapper = styled.div`
  .slick-slide {
    padding: 10px;
  }

  .slick-dots li button:before {
    color:rgb(5, 53, 209);
    font-size: 12px;
  }

  .slick-prev,
  .slick-next {
    z-index: 1;
    background-color: #023a5b;
    color:rgb(23, 166, 249);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .slick-prev:hover,
  .slick-next:hover {
    background-color:rgb(41, 139, 251);
  }
`;

const ServiceCard = styled.div`
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  display: flex;
  flex-direction: column; /* Ensures items stack vertically */
  justify-content: space-between; /* Adds space between title, description, and buttons */
  align-items: center;
  height: 400px; /* Fixed height for uniformity */
  padding: 1rem;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
  }
`;


const CardImageWrapper = styled.div`
  width: 100%;
  height: 200px;
  border-radius: 1px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.1);
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ServiceTitle = styled.h5`
  font-size: 1.3rem;
  color: #023a5b;
  margin: 1rem 0 0.5rem;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -3px;
    width: 0;
    height: 3px;
    background-color: rgb(222, 18, 18);
    transition: width 0.3s ease-in-out;
  }

  &:hover::after {
    width: 50%;
  }

  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;

const ServiceDescription = styled.p`
  font-size: 1rem;
  color: #666;
  line-height: 1.5;
  margin-bottom: 1rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;

// const OrderButton = styled.button`
//   background-color: #023a5b;
//   color: white;
//   padding: 10px 20px;
//   border-radius: 20px;
//   font-size: 0.95rem;
//   cursor: pointer;
  

//   &:hover {
//     background-color: #025b50;
//   }
// `;

const LightboxOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const LightboxContent = styled.div`
  background: linear-gradient(135deg, #ffffff, #f4f4f4);
  padding: 10px;
  border-radius: 10px;
  max-width: 800px;
  width: 90%;
  text-align: center;
  position: relative;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.3s ease;

  @media (max-height: 600px) {
   max-height: 90vh; /* Prevent content from exceeding viewport height */
  overflow-y: auto; /* Enable scrolling for overflowing content */

  @media (max-width: 480px) {
    max-height: 80vh; /* Reduce max height on very small devices */
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
const LightboxTitle = styled.h2`
  font-size: 1.3rem;
  color: #023a5b;
  font-weight: 700;
  margin-bottom: 15px;

  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;

const LightboxDescription = styled.p`
  color: #444;
  font-size: 1.1rem;
  line-height: 1.6;
  margin: 20px 0;
  max-height: 300px;
  overflow-y: auto;
  @media (max-width: 768px) {
    max-height: 200px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: #fff;
  border: none;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  color: #ff5757;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    color: #c21e56;
    transform: scale(1.1);
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 768px) {
    top: 15px;
    right: 15px;
    width: 35px; /* Slightly smaller size for mobile */
    height: 35px;
    font-size: 14px;
  }

  @media (max-width: 480px) {
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    font-size: 12px;
  }
`;


const LightboxImage = styled.img`
  width: 100%; /* Span the entire width of the lightbox */
  height: auto; /* Maintain the aspect ratio */
  max-height: 300px; /* Limit the height to give a banner-like feel */
  object-fit: cover; /* Ensures the image covers the container nicely */
  border-radius: 8px; /* Slightly rounded corners */
  margin-bottom: 15px; /* Space below the image */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* Add a soft shadow */
`;


const ReadMoreButton = styled.button`
  background: none;
  border: none;
  color: #023a5b;
  cursor: pointer;
  font-weight: bold;
  margin-top: 10px;
  &:hover {
    text-decoration: underline;
  }
`;

const CTAButton = styled(Link)`
  display: inline-block;
  background: #023a5b;
  color: white;
  padding: 12px 30px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-top: 20px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);

  &:hover {
    background: #025b50;
    transform: translateY(-3px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
  }
`;
